module.exports = __webpack_public_path__ + "img/facebook_cn.cd2c1fa1.png";